import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1be16c54"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Регистрация ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _ctx.$route.name !== 'sign-up' && _ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: {
      name: 'sign-up'
    },
    class: "button registration-button"
  }, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  })) : _createCommentVNode("", true);
}